import { gql } from "@apollo/client";

const GET_USER = gql`
  query getUsers(
    $cursor: Int
    $limit: Int
    $roleID: Int
    $query: String
    $panelType: String!
    $mainSuperAdminId: ID!
    $needPage: Boolean
    $deletedUsersOnly: Int
    $verifiedOnly: Boolean
  ) {
    getUsers(
      cursor: $cursor
      limit: $limit
      roleID: $roleID
      query: $query
      panelType: $panelType
      mainSuperAdminId: $mainSuperAdminId
      needPage: $needPage
      deletedUsersOnly: $deletedUsersOnly
      verifiedOnly: $verifiedOnly
    ) {
      users {
        id
        picture
        pseudonym
        name
        jobTitle
        username
        email
        status
        createdAt
        # managerId {
        #   id
        # }
        agentlimitchatassign
        agentcommentlimit
        chatbotlimit
        designation {
          id
          name
          paneltype
        }
        number
        pagesIdArray
        commentPages
        chatbotBots
        assignedTwilioNumbers
        mainSuperAdminId
        verified
      }
      hasNextPage
    }
  }
`;
export default GET_USER;
